<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="text-xs-center">
        <v-dialog :scrollable=true
                  persistent
                  @keydown.esc="closeDialog"
                v-model="$store.getters.checkDialog"
                width="700"
        >
            <v-card>
                <v-card-title
                        class="headline secondary  white--text justify-center"
                        primary-title>
                    {{this.$store.getters.bookInfoModal.title}}
                </v-card-title>

                <v-card-text>
                    <v-tabs
                            centered
                            height="65px"
                            icons-and-text
                            light>
                        <v-tabs-slider color="primary"></v-tabs-slider>

                        <v-tab active-class="default-class elevation-24" href="#tab-1">
                            Πληροφορίες συγγράμματος
                        </v-tab>

                        <v-tab active-class="default-class elevation-24" href="#tab-2">
                            Εξώφυλλο
                        </v-tab>

                        <v-tab active-class="default-class elevation-24" href="#tab-3">
                            Οπισθόφυλλο
                        </v-tab>

                        <v-tab-item
                                :id="'tab-' + i"
                                :key="i"
                                v-for="i in 3"><br>
                            <v-layout align-start
                                      fill-height row space-between v-if="i === 1">
                                <v-list subheader>

                                    <v-list-tile class="mb-3">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Κωδικός Συγγράμματος:</v-list-tile-title>
                                            <v-list-tile-sub-title>{{$store.getters.bookInfoModal.id}}
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Συγγραφείς:</v-list-tile-title>
                                            <v-list-tile-sub-title>{{$store.getters.bookInfoModal.authors}}
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <v-list-tile-content>
                                            <v-list-tile-title>ISBN:</v-list-tile-title>
                                            <v-list-tile-sub-title>{{$store.getters.bookInfoModal.isbn}}
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Εκδόσεις:</v-list-tile-title>
                                            <v-list-tile-sub-title>{{$store.getters.bookInfoModal.editorialHouse}}
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Αριθμός Σελίδων:</v-list-tile-title>
                                            <v-list-tile-sub-title>{{$store.getters.bookInfoModal.pages}}
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Διαθέτης (Εκδότης):</v-list-tile-title>
                                            <v-list-tile-sub-title>{{$store.getters.bookInfoModal.publisherName}}
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Ιστοσελίδα Συγγράμματος:</v-list-tile-title>
                                            <v-list-tile-sub-title @click="openPathBook($store.getters.bookInfoModal.linkToPublisher)"
                                                                   class="align-end pointerCursor"><i>Πατήστε εδω</i>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Πίνακας Περιεχομένων:</v-list-tile-title>
                                            <v-list-tile-sub-title @click="openPathBook($store.getters.bookInfoModal.pathToTOC)"
                                                                   class="align-end pointerCursor"><i>Πατήστε εδω</i>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Ενδεικτικό Απόσπασμα:</v-list-tile-title>
                                            <v-list-tile-sub-title @click="openPathBook($store.getters.bookInfoModal.pathToChapter)"
                                                                   class="align-end pointerCursor"><i>Πατήστε εδω</i>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-layout>

                            <v-layout align-center justify-center v-if="i === 2">
                                <v-card hover width="400px">
                                    <v-img :src="getCoverUrl($store.getters.bookInfoModal.pathToCover)"
                                           class="white--text"
                                           max-width="400px">
                                    </v-img>
                                </v-card>
                            </v-layout>

                            <v-layout align-center justify-center v-if="i === 3">
                                <v-card hover width="400px">
                                    <v-img :src="getCoverUrl($store.getters.bookInfoModal.pathToBackcover)"
                                           class="white--text"
                                           max-width="400px">
                                    </v-img>
                                </v-card>
                            </v-layout>
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click.native="closeDialog"
                            color="primary darken-0">
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>

    import util from '../../utilities.js';

    export default {
        name: "BookInfoModal",
        props: {
            dialog: Boolean,
            semesterInfo: Array
        },
        data: () => ({
        }),
        methods: {
            closeDialog() {
                this.$store.commit('setDialog', false);
            },
            getCoverUrl(path) {
                return util.containsPathToBook(path)
            },
            openPathBook(path) {
                window.open(util.containsPathToBook(path,'_blank'));
            }
        }
    }
</script>

<style scoped>

</style>
